module.exports = __webpack_public_path__ + "img/join-wh.86210838.jpg";